import { SubscriptionPeriodType } from '../../../models/Article';
import { shopPrefix } from '../../config';
import { http } from '../axios';
import { BulkAddProductsToShoppingCartResponse, CatalogueSearchScope, ProductFilter } from '../../store/api';

export type BulkAddProductsByCatalogueSearchRequest = {
    query: string;
    refine: string | null;
    filterRequest: ProductFilter;
    scope: CatalogueSearchScope;
    targetPrice: string;
    subscriptionPeriodType: SubscriptionPeriodType;
    shopLanguage: string | undefined;
    excludedProductIds?: string[];
};

type Params = { performChecks: boolean };

type Options = {
    body: BulkAddProductsByCatalogueSearchRequest;
    params: Params;
};

const url = `${shopPrefix}/v2/shoppingcart/bulk/catalogue/search/add`;

export const addProductsFromCatalogueBySearch = ({ body, params }: Options) => {
    return http.post<BulkAddProductsToShoppingCartResponse>(url, body, { params }).then(res => res.data);
};
